import React from 'react';

function PreLoader() {
    return(
        <div id="preloader">
            <div id="status">
                <div class="status-mes"></div>
            </div>
        </div>
    )
}

export default PreLoader;